import '../App.css';
//IMPORTS DE LA BASE
import ProductsBase from "../components/products/ProductBasePage";
import background from '../assets/img/fondo.jpg'
import backgroundBusiness from '../assets/img/fondo2.jpg'
import logo from "../assets/img/advise_consultore_logo-removebg-preview.png"
import monitor from "../assets/img/monitor-sigger360.png"
import "../assets/styles/paneles.css"
import { PanelesEnum } from "../enums/PanelesEnum";
//IMPORTS DE LAS CARACTERISTICAS
import ProductCharacteristics from "../components/products/ProductCharacteristics";
import char0 from "../assets/img/paneles/char0.png"
import char1 from "../assets/img/paneles/char1.png"
import char2 from "../assets/img/paneles/char2.png"
import char3 from "../assets/img/paneles/char3.png"
import char4 from "../assets/img/paneles/char4.png"
import char5 from "../assets/img/paneles/char5.png"
import char6 from "../assets/img/paneles/char6.png"
import char7 from "../assets/img/paneles/char7.png"
import char8 from "../assets/img/paneles/char8.png"
import char9 from "../assets/img/paneles/char9.png"
//IMPORTS DEL FOOTER
import ProductContactUs from '../components/products/ProductConctactUs';

import Footer from "../components/Footer";
import { ServiceEnums } from '../enums/ServicesEnum';

export default function PanelesSolaresAdvise(props){

    const productBaseProps = {
        isLargeScreen: props.isLargeScreen,
        background: background,
        backgroundBusiness: backgroundBusiness,
        logo: logo,
        mainTitle: PanelesEnum.PRODUCT_TITLE,
        mainDescription: PanelesEnum.PRODUCT_DESCRIPTION,
        screenshot: monitor,
        referenceComponent: "service-card-4"
    }

    const productCharacterisitcsProps = {
        isLargeScreen: props.isLargeScreen,
        data: [
            {
                title: PanelesEnum.OUR_SOLUTION_1_TITLE,
                description: PanelesEnum.OUR_SOLUTION_1_DESC,
                imgLink: [char0]
            },
            {
                title: PanelesEnum.OUR_SOLUTION_8_TITLE,
                description: PanelesEnum.OUR_SOLUTION_8_DESC,
                imgLink: [char7,char8,char9]
            },
            {
                title: PanelesEnum.OUR_SOLUTION_2_TITLE,
                description: PanelesEnum.OUR_SOLUTION_2_DESC,
                imgLink: [char1]
            },
            {
                title: PanelesEnum.OUR_SOLUTION_3_TITLE,
                description: PanelesEnum.OUR_SOLUTION_3_DESC,
                imgLink: [char2]
            },
            {
                title: PanelesEnum.OUR_SOLUTION_4_TITLE,
                description: PanelesEnum.OUR_SOLUTION_4_DESC,
                imgLink: [char3]
            },
            {
                title: PanelesEnum.OUR_SOLUTION_5_TITLE,
                description: PanelesEnum.OUR_SOLUTION_5_DESC,
                imgLink: [char4]
            },
            {
                title: PanelesEnum.OUR_SOLUTION_6_TITLE,
                description: PanelesEnum.OUR_SOLUTION_6_DESC,
                imgLink: [char5]
            },
            {
                title: PanelesEnum.OUR_SOLUTION_7_TITLE,
                description: PanelesEnum.OUR_SOLUTION_7_DESC,
                imgLink: [char6]
            }
        ]
    }

    const productsContactProps = {
        isLargeScreen: props.isLargeScreen,
        nameProducto: "SiGGER 360",
        contactTitle: PanelesEnum.CONTACT_TITLE,
        contactDesc: PanelesEnum.CONTACT_DESCRIPTION
    }

    return(
        <>
            <ProductsBase {...productBaseProps}/>
            <div className='information-section'>
                <ProductCharacteristics {...productCharacterisitcsProps}/>
                <ProductContactUs {...productsContactProps}/>    
                <Footer isService={true} origin={ServiceEnums.SIGGER}/>     
            </div>     
        </>
    )
}